import React from 'react';

import { Link } from 'react-router-dom';
const Popup = () => {
    // const [show, setShow] = useState(false);
    const howItWorks = () => {
        window.PopUp('hide');
    }

    return (
        <div id="ac-wrapper" style={{ display: 'hidden' }}>

            <div id="popup">
                <button class="close" onClick={howItWorks}  ><i class="fa fa-close"></i></button>
                <h2>Have any Querry?</h2>
                <div className="fel">
                    <Link to="/contact" className="bt">
                        Contact us
                    </Link>
                </div>
                {/* <input type="button"   value="hola"  /> */}

            </div>
        </div>
    )
}

export default Popup
